// extracted by mini-css-extract-plugin
export var orderDetails = "_to-2";
export var orderImage = "_to-1";
export var orderMeta = "_to-3";
export var orderSummary = "_to-0";
export var rightArrow = "_to-4";